class HgsTemplateLoader {
  hid: string;

  constructor() {
    this.hid = $("meta[name=hid]").attr("content");
  }

  /** This function executes all template processes */
  cleanPage() {
    this.setupHospitalSelection(this.hid);
  }

  setupHospitalSelection(hid: string) {
    $.ajax("/api/session/hospital/", {
      data: { id: hid },
    });
  }
}

const loader = new HgsTemplateLoader();
loader.cleanPage();

export {};
